import { render, staticRenderFns } from "./UserProfilDetails.vue?vue&type=template&id=7daaa63b&scoped=true&"
import script from "./UserProfilDetails.vue?vue&type=script&lang=js&"
export * from "./UserProfilDetails.vue?vue&type=script&lang=js&"
import style0 from "./UserProfilDetails.vue?vue&type=style&index=0&id=7daaa63b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7daaa63b",
  null
  
)

export default component.exports